import { environment as envStaging } from './environment.staging';

export const environment = {
  ...envStaging,
  production: true,
  BASE_BACKEND_URL: 'https://backend.channels.app',
  SSO_URL: 'https://sso.channels.app',
  WEB_CALL_SCRIPT_URL: 'https://web-call.channels.app/widget.js',
  WEB_WIDGET_URL: 'https://make-a-call-with.channels.app',
  IFRAME_ADDRESS: 'https://crazy-website-widget.crazycall.com/',
  CRAZYCALL_BACKEND_URL: 'https://backend.channels.app',
  SENTRY_ENABLED: true,
  WEB_CALL_BACKEND_CONFIGURATOR_URL: 'https://web-call-generator.channels.app/',
  APP_ID: '',
  INTERNATIONALIZATION_URL: 'https://s3-eu-west-1.amazonaws.com/crazycall-preprod2-internationalization/web-frontend/',
  TYPEFORM_URL: 'https://andrzejmuzaj.typeform.com/to/vNSmdG',
  LEAD_GENERATION_ENV: 'preprod',
  CHANNELS_URL: 'https://my.channels.app',
  BACKEND_CHANNELS_URL: 'https://backend.channels.app',
  SHOPER_CONNECT_URL: 'https://app.shoperconnect.pl',
  PIPEDRIVE_INTEGRATION_URL: 'https://marketplace.pipedrive.com/app/channels/521dbfc0e3648cea',
  SHOPIFY_INTEGRATION_URL: 'https://apps.shopify.com/channels',
  TWO_WAY_INTEGRATION_URL: 'https://my.2way.app/channels/login',
  AMPLITUDE_API_KEY: '856346d64394341d5d026a9e102cc051',
  CHROME_STORE_WIDGET_ID: 'hmfoachifajaajjebifbjklokdcdbjke',
  ZAPIER_INTEGRATION_URL: 'https://zapier.com/apps/channels/integrations'
};
